import HighSchoolTrainingOverdueBannerContainer from './container'

export default HighSchoolTrainingOverdueBannerContainer
